import React from "react";
import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormHelperText,
  FormControl,
  Box,
  Typography,
} from "@mui/material";

/**
 * Accessible checkbox with optional fine-print helper text.
 */
const Checkbox = ({
  checked,
  onChange,
  label,
  finePrint,
  error,
  helperText,
  required = false,
  name,
  disabled = false,
  sx,
}) => {
  return (
    <FormControl error={!!error} sx={{ width: "100%", ...sx }}>
      <FormControlLabel
        sx={{ alignItems: "flex-start", ml: 0, mr: 0 }}
        control={
          <MuiCheckbox
            name={name}
            checked={!!checked}
            onChange={(e) => onChange?.(e.target.checked, e)}
            disabled={disabled}
            required={required}
            sx={{
              pt: 0.25,
              color: "#0f172a",
              "&.Mui-checked": { color: "#0f172a" },
            }}
          />
        }
        label={
          <Box>
            <Typography
              component="span"
              sx={{
                fontFamily: `'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
                fontSize: "0.875rem",
                fontWeight: 600,
                color: "#0f172a",
                display: "block",
                lineHeight: 1.45,
              }}
            >
              {label}
              {required ? " *" : ""}
            </Typography>
            {finePrint ? (
              <Typography
                component="span"
                sx={{
                  fontFamily: `'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
                  fontSize: "0.75rem",
                  color: "#64748b",
                  display: "block",
                  mt: 0.75,
                  lineHeight: 1.55,
                  whiteSpace: "pre-line",
                }}
              >
                {finePrint}
              </Typography>
            ) : null}
          </Box>
        }
      />
      {(error || helperText) && (
        <FormHelperText sx={{ ml: 0, mt: 0.5 }}>{helperText || (error ? "Required" : "")}</FormHelperText>
      )}
    </FormControl>
  );
};

export default Checkbox;
